<div class="page-layout carded fullwidth" fusePerfectScrollbar>
  <div class="top-bg mat-accent-bg"></div>
  <div class="center">
    <div class="header white-fg">
      <div class="logo">
        <ng-content select="[back-button]"></ng-content>
        <mat-icon class="logo-icon" *fuseIfOnDom
                  [@animate]="{value:'*',params:{delay:'50ms',scale:'0.2'}}">
          {{icon()}}
        </mat-icon>
        <div class="title-wrapper" *fuseIfOnDom>
          <div class="h1">
            {{ title() | translate }}
          </div>
          @if (subtitle()) {
            <div class="subtitle secondary-text">
              <span>{{ subtitle() | translate }}</span>
            </div>
          }
        </div>
      </div>
      @if (showSearch()) {
        <div class="search-input-wrapper">
          <label for="search" class="search-label">
            <mat-icon class="secondary-text">search</mat-icon>
          </label>
          <mat-form-field class="page-search">
            <mat-label>{{ 'main.search' | translate }}</mat-label>
            <input id="search" matInput #filter>
          </mat-form-field>
        </div>
      }
      <div>
        <ng-content select="[buttons]"></ng-content>
      </div>
    </div>

    @if (showFilter()) {
      <button mat-button class="mat-icon-button sidenav-toggle" (click)="sidenav?.toggle()">
        <mat-icon>filter_list</mat-icon>
      </button>
    }

    <mat-sidenav-container class="sidenav-container">
      <!-- Sidenav exists only when filtering is enabled -->
      @if (showFilter()){
        <mat-sidenav #sidenav mode="side" opened="true" position="end">
          <div class="filter-card">
            <ng-content select="[filter-content]"></ng-content>
          </div>
        </mat-sidenav>
      }
      <!-- Always present: main content projection outside any conditional -->
      <mat-sidenav-content>
        <div class="content-card mat-white-bg">
          <ng-content select="[main-content]"></ng-content>
        </div>
      </mat-sidenav-content>
    </mat-sidenav-container>

<!--    @if (showFilter()) {-->
<!--      <button mat-button class="mat-icon-button sidenav-toggle"-->
<!--              (click)="sidenav.toggle()">-->
<!--        <mat-icon>filter_list</mat-icon>-->
<!--      </button>-->
<!--      <mat-sidenav-container class="sidenav-container">-->

<!--        <mat-sidenav #sidenav mode="side" opened="true" position="end">-->
<!--          <div class="filter-card">-->
<!--            <ng-content select="[filter-content]"></ng-content>-->
<!--          </div>-->
<!--        </mat-sidenav>-->

<!--        <mat-sidenav-content>-->
<!--          <div class="content-card mat-white-bg">-->
<!--            <ng-content select="[main-content]"></ng-content>-->
<!--          </div>-->
<!--        </mat-sidenav-content>-->
<!--      </mat-sidenav-container>-->
<!--    }-->

<!--    @if (!showFilter()) {-->
<!--      <div class="content-card mat-white-bg">-->
<!--        <ng-content select="[main-content]"></ng-content>-->
<!--      </div>-->
<!--    }-->

  </div>
</div>
